import axios from 'axios'
import i18n from "../../public/lang/index"

import { qsStringify } from '../util/querystring';

export const baseUrl = process.env.VUE_APP_BASE_URL
export const basePath = baseUrl + process.env.VUE_APP_BASE_PATH;
export const basePathUrl = basePath;
// export const basePathUrl = basePath + '/public/api/v1/';
export const hzmbgh_baseUrl = process.env.VUE_APP_HZMB_GH_BASE_PATH;

export const resourcePath = process.env.VUE_APP_BASE_RESOURCE_PATH;

axios.defaults.baseURL = basePathUrl;

axios.defaults.withCredentials = true;
axios.defaults.timeout = 72000000

axios.defaults.paramsSerializer = function (params) {
    return qsStringify(params);
};

import router from '../router'
import {
    MessageBox
} from 'element-ui';

axios.interceptors.request.use(
    config => {
        // if (config.url.indexOf("/login") != -1 || config.url.indexOf("/logout") != -1 || config.url.indexOf('/error/log') != -1 || config.url.indexOf('check-vehicle') != -1) {
        //     config.baseURL = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_PATH;
        // } else 
        if (config.url.indexOf(process.env.VUE_APP_BOOKING_BASE_SERVER_PATH) != -1) {
            config.baseURL = "";
        }
        if(config.url.indexOf(hzmbgh_baseUrl) !== -1) {
            config.baseURL = '';
        }

        // 語言參數
        const lan = i18n.t('message.lang') || 'ZH_HANT';
        config.headers['Language'] = lan;

        if (config.url.indexOf("cadastre") != -1) {
            config.baseURL = '/cadastre'
        } else if (config.url.indexOf("/guide") != -1) {
            config.baseURL = process.env.VUE_APP_BASE_LOCAL_PATH
        } else {
            if (localStorage.getItem('authentication')) {
                config.headers['authentication'] = localStorage.getItem('authentication');
            }
        }
        return config
    },
    err => {
        return Promise.reject(err)
    }
)

var showDialog = false
axios.interceptors.response.use(
    (response) => {
        return response
    }, (err) => {
        const response = err.response || null;
        const data = response && response.data || {}
        if (response && response.status && response.status == 401) {
            if (!showDialog) {
                showDialog = true
                const serviceType = localStorage.getItem('serviceType') || null;
                const personalType = localStorage.getItem('personalType') || null;
                if (serviceType == 'HZMB_FIRST_PERSON' || serviceType == 'HZMB_RENEW_PERSON') {
                    router.push(personalType == 'phone' ? '/personal/phone' : '/personal');
                } else if (serviceType == 'HZMB_FIRST_COMPANY' || serviceType == 'HZMB_RENEW_COMPANY') {
                    router.push('/company');
                } else if (serviceType == "TAXI_ANNUAL") {
                    router.push('/entryTaxi');
                } else if (serviceType == "DRV_LIC_INTER") {
                    router.push('/entryInternational');
                } else if (serviceType == 'HEADMASTER_RENEW' || serviceType == 'COACH_RENEW' || serviceType == 'SCHOOL_RENEW') {
                    router.push('/entrySchool');
                } else if (['HZMB_G_FIRST','HZMB_G_RENEW', 'HZMB_G_CANCEL'].includes(serviceType)) {
                    router.push('/hzmb-truck-hk');
                } else if (['HZMB_H_FIRST_PERSON', 'HZMB_H_RENEW_PERSON', 'HZMB_H_CANCEL_PERSON', 'HZMB_H_FIRST_COMP', 'HZMB_H_RENEW_COMP', 'HZMB_H_CANCEL_COMP'].includes(serviceType)) {
                    router.push('/hzmb-truck-mo');
                } else if (['HZMB_GH_CHANGE_COMP'].includes(serviceType)) {
                    router.push('/entryBus');
                } else if (serviceType === "HZMB_H_BOOKING") {
                    let verifyForm = localStorage.getItem("verifyForm");
                    verifyForm = verifyForm ? JSON.parse(verifyForm) : {};
                    localStorage.setItem("verifyForm", JSON.stringify({...verifyForm, token: null}));
                    router.push('/hzmb-truck-mo-booking');
                } else {
                    router.push('/entry');
                }
                const { code } = response.data;
                MessageBox.confirm(i18n.t('message.reLogin') + `${code ? ` (${code})` : ''}`, i18n.t('message.tips'), {
                    distinguishCancelAndClose: true,
                    showClose: false,
                    showCancelButton: false,
                    type: 'warning',
                    closeOnClickModal: false
                }).then(() => {
                    showDialog = false
                }).catch(() => {
                    showDialog = false
                });
            }
        }
        return Promise.reject({
            status: response && response.status,
            code: data && (data.errorCode || data.code),
            message: data && data.message,
            data: data,
            raw: err
        })
    }
)

export default axios